
import { CITY_PAGE_API } from '../config/apiPoints';
import { fetchHelper } from '../../utils/fetchHelper';
import getDateObj from '../Common/utils/GetDateObj';

export const prepareCityPageRequest = (params) => {
  const url = `${__ENV_CONFIG__.__PAGEROVER__}${CITY_PAGE_API}${params.city}`
  return url;
}

export const getCityPageData = async (params) => {
  const url = prepareCityPageRequest(params);
  let data = {}
  try {
    data = await fetchHelper({
      name: 'route page',
      type: 'GET',
      url: url,
    });
  } catch (err) {
    data = { status: false, error: true }
  }
  return data;
}

export const getCityKey = (city, str) => {
  const d = getDateObj();
  const year = d.getFullYear();
  const month = d.getMonth();
  const day = d.getDate();

  return `bus_mweb_city_${city}_${year}-${+month + 1}-${day}${str ? `_${str}` : ''}`
}
